import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type dashboardCoachPermissionType = 'dashboard_coach_view';

export const dashboardCoachPermissionMatrix: IPermissionMatrix<dashboardCoachPermissionType> = {
  dashboard_coach_view: [UserRole.coach]
};
